<template lang="html">
  <article class="media">
    <div class="media-content">
      <div class="content">
        <p>
          <strong>Technical Support Engineer</strong> | Kaplan International - <small>March 2012 - 2014</small>
          <br>
At Kaplan I was responsible for system administration tasks including monitoring
and maintaining servers as well as our hub and spoke network. I traveled to
upgrade network, server and desktop infrastructure across our 22 branch
locations. My use of scripting, inventory tracking, and deployment systems
optimized our efficiency and minimized travel. These methodologies reduced the
time to plan and execute many tasks by months.
        </p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "kaplan"
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/jobs/Kaplan.vue